import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyCyLjDxB1YEwK6NnafcTKDhQ1DmTInJeGU",
  authDomain: "own-a6c6f.firebaseapp.com",
  projectId: "own-a6c6f",
  storageBucket: "own-a6c6f.appspot.com",
  messagingSenderId: "883791813604",
  appId: "1:883791813604:web:423c6f3060316de5a445f1",
  measurementId: "G-4KZC4RKN9Q"
};

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();

  const auth = firebase.auth();


  export {db, auth};